import { Component, OnInit } from '@angular/core';
import { AppCommunicationService } from 'app/+app-custom/services/app-communication.service';
import { SYSTEM_NAME } from 'app/+app-custom/app.settings';
/* global ReportBug */

@Component({
    selector: 'app-sa-footer',
    templateUrl: './footer.component.html',
    styles: [`
        .row {
            width: 100%;
            color: var(--footer-text-color);
        }
    `]
})
export class FooterComponent implements OnInit {

    currentDate: string;

    constructor() {}

    ngOnInit() {
        this.currentDate = Date();
    }

    openReportDialog(e: Event) {
        e.preventDefault();

        // @ts-ignore
        ReportBug.openDialog(
            SYSTEM_NAME,
            AppCommunicationService.getCurrentUser().user,
            () => {},
            (error) => {},
            () => {
            }
        ); // Call the function from the ReportBug module
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/layout/footer/footer.component.ts